/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { IAny } from '../../DashboardKPIWidgets/IEnergyManagementProps';
import CommonProgressBar from '../CommonProgressBar/CommonProgressBar';

//While the ternary operator is pleasingly compact, use only if/else
export const getBarColorClass = (deviation: number): string => {
  if (deviation >= 0) {
    return 'green';
  } else {
    return 'red';
  }
};

export const renderActualCost = (rowData: IAny, currencyconverter: string) => {
  return (
    <span className="score-category-meterdata">
      <span className="score-category-percent">
        <div className="measurementunit">{currencyconverter}</div>
      </span>
      <span className="score-category-progress">
        <CommonProgressBar
          actual={rowData.totalActualCost}
          previousPeriod={rowData.previousPeriodCost}
          savings={rowData.totalCostSavings}
          savingsPercentage={rowData.totalCostSavingsPercentage}
          progessBarRelativeWidth={rowData.progessBarRelativeWidthCost}
        />
      </span>
    </span>
  );
};
